module.exports = __webpack_public_path__ + "img/2.1d55762d.png";